import {
  endpointKeys,
  SharingLinkAggregatedActivitiesParams,
  SharingLinkLatestActivitiesParams,
  SharingLinkMeasurementsParams,
  SharingLinkParams,
  CushlaGetQueryOptions,
} from '@common/api'
import {
  AggregatedActivity,
  BasicHealthInfoResponse,
  CriticalNote,
  LatestActivity,
  LinkValidationResponse,
  PagedResponse,
  QuestionnaireMeasurement,
} from '@common/models'
import {
  aggregatedActivitiesNormaliser,
  basicHealthInfoNormaliser,
  criticalNoteOrNullNormaliser,
  getPagedResponseNormaliser,
  latestActivityNormaliser,
  linkValidationResponseNormaliser,
  measurementNormaliser,
} from '@common/normalisers'

import {useApi, useWebGet} from './helpers'

export const useValidateLinkPassword = (
  params: SharingLinkParams,
  options?: CushlaGetQueryOptions<LinkValidationResponse>,
) =>
  useWebGet<LinkValidationResponse>(
    [endpointKeys.sharingLinkValidation, params],
    useApi().sharingLinkValidation(params),
    linkValidationResponseNormaliser,
    options,
    false,
  )

export const useGetSharingLinkMeasurements = (
  params: SharingLinkMeasurementsParams,
  options?: CushlaGetQueryOptions<PagedResponse<QuestionnaireMeasurement>>,
) =>
  useWebGet<PagedResponse<QuestionnaireMeasurement>>(
    [endpointKeys.sharingLinkMeasurements, params],
    useApi().sharingLinkMeasurements(params),
    getPagedResponseNormaliser(measurementNormaliser),
    options,
    false,
  )

export const useGetSharingLinkBasicHealthInfo = (
  params: SharingLinkParams,
  options?: CushlaGetQueryOptions<BasicHealthInfoResponse>,
) =>
  useWebGet<BasicHealthInfoResponse>(
    [endpointKeys.sharingLinkBasicHealthInfo, params],
    useApi().sharingLinkBasicHealthInfo(params),
    basicHealthInfoNormaliser,
    options,
    false,
  )

export const useGetSharingLinkAggregatedActivities = (
  params: SharingLinkAggregatedActivitiesParams,
  options?: CushlaGetQueryOptions<AggregatedActivity[]>,
) =>
  useWebGet<AggregatedActivity[]>(
    [endpointKeys.sharingLinkAggregatedActivities, params],
    useApi().sharingLinkAggregatedActivities(params),
    aggregatedActivitiesNormaliser,
    options,
    false,
  )

export const useGetSharingLinkLatestActivities = (
  params: SharingLinkLatestActivitiesParams,
  options?: CushlaGetQueryOptions<LatestActivity>,
) =>
  useWebGet<LatestActivity>(
    [endpointKeys.sharingLinkLatestActivities, params],
    useApi().sharingLinkLatestActivities(params),
    latestActivityNormaliser,
    options,
    false,
  )

export const useGetSharingLinkCriticalNote = (
  params: SharingLinkParams,
  options?: CushlaGetQueryOptions<CriticalNote | null>,
) =>
  useWebGet<CriticalNote | null>(
    [endpointKeys.sharingLinkCriticalNote, params],
    useApi().sharingLinkCriticalNote(params),
    criticalNoteOrNullNormaliser,
    options,
    false,
  )
